import { UpdateGoogleSheetsConfigResponse } from "./../integration.service.d";
import { put, select } from "redux-saga/effects";
import { updateGoogleSheetsConfigFailure, updateGoogleSheetsConfigSuccess } from "../actionCreators";
import { IntegrationService } from "../integration.service";
import { IUpdateGoogleSheetsConfigRequestData } from "../types";

export function* updateGoogleSheetsConfigSaga(action: { type: string; payload: IUpdateGoogleSheetsConfigRequestData }) {
    try {
        const { targetSheet, fields, subSheetName, includeSubDate, includeSubId, includeSubIp, includeAllFields } =
            action.payload;
        const formId: string = yield select(state => state.forms.current._id);
        const data = {
            targetSheet,
            fields,
            subSheetName,
            includeSubDate,
            includeSubId,
            includeSubIp,
            includeAllFields,
        };
        const response: UpdateGoogleSheetsConfigResponse = yield IntegrationService.updateGoogleSheetsConfig(
            formId,
            data,
        );

        yield put(updateGoogleSheetsConfigSuccess(response));
    } catch (error: any) {
        const errorMessage = error.response?.message || "Failed to update Google Sheets";

        console.error("Error updating Google Sheets config:", error);
        yield put(updateGoogleSheetsConfigFailure(errorMessage));
    }
}
